import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SecretRoutingModule } from './secret-routing.module';
import { SecretComponent } from './components/secret/secret.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SecretFormComponent } from './components/secret-form/secret-form.component';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';


@NgModule({
  declarations: [
    SecretComponent,
    SecretFormComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    RouterModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    MatListModule,
    SecretRoutingModule
  ],
  exports: [
    SecretComponent
  ]
})
export class SecretModule { }
